<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="搜索可合并邮寄的订单" :width="900" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel" okText="加入合并列表">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="9" :sm="24">
                            <a-form-item label="公司名称">
                                <a-input v-model:value="queryParam.full_name" placeholder="输入公司名称"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="9" :sm="24">
                            <a-form-item label="续费联系人号码">
                                <a-input v-model:value="queryParam.xftel" placeholder="输入手机号"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id"
                :row-selection="{ selectedRowKeys: state.selectids, type: 'multiple', onChange: onSelectChange }">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.key === 'xftel'">
                        {{ record.xftel || '未填写' }}
                    </template>
                    <template v-else-if="column.key === 'action'">
                        <a-tag color="green">{{ record.business_type_name }}：{{ record.after_status_name }}</a-tag>
                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    customerId: {
        type: Number,
        default: () => null
    },
    customerOtherIds: {
        type: Array as () => number[],
        default: () => []
    }
})
const columns = [
    { title: '公司名称', dataIndex: 'full_name', key: 'full_name', ellipsis: true },
    { title: '货架号', dataIndex: 'storeShelfCode', key: 'storeShelfCode', width: 100 },
    { title: '续费联系人', key: 'xftel', width: 150 },
    { title: '业务状态', key: 'action', width: 180 }
]
interface state {
    loading: boolean
    detailData: object
    selectids: any[] // 选中的id
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    selectids: [],
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customerSfMergeList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, customer_id: props.customerId }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.length
        dataSource.value = res.data.map((item) => ({ ...item, isDetail: false }))

        const checkedIds = new Set(props.customerOtherIds)
        state.selectids = dataSource.value
            .filter((item: any) => checkedIds.has(item.id))
            .map((item: any) => item.id)
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onSelectChange = (selectedRowKeys: any[], val) => {
    state.selectids = selectedRowKeys
}
const onFormSubmit = () => {
    if (!state.selectids.length) {
        message.warning('请至少选择一条订单')
        return
    }
    const selectedRows = dataSource.value.filter((item: any) =>
        state.selectids.includes(item.id)
    )
    emit('ok', selectedRows)
}
const cancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
